import { z } from 'zod'

export const ADMINPUBLICGET_CONTRACT_VERSION = '1.0.0' as const
export const adminPublicGetResponseSchema = z.unknown()
export type AdminPublicGetResponse = z.infer<typeof adminPublicGetResponseSchema>
